"use client";
import React, { useState } from 'react';
import { useDarkMode } from '../darkModeContext';
import { useTranslation } from 'react-i18next';
import emailjs from 'emailjs-com';

const ContactUs = () => {
    const { t, i18n } = useTranslation();
    const isDarkMode = useDarkMode();

    const [formValues, setFormValues] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({
        ...formValues,
        [name]: value,
        });
    };

    const validate = () => {
        const newErrors = {};

        if (!formValues.firstName) {
        newErrors.firstName = 'Nom manquant';
        }
        if (!formValues.email || !/\S+@\S+\.\S+/.test(formValues.email)) {
        newErrors.email = 'Email invalide ou manquant';
        }
        if (!formValues.message) {
        newErrors.message = 'Message manquant';
        }

        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            // EmailJS integration
            emailjs.send(
                'service_5bfkg8e', 
                'template_52sayac',
                {
                    from_name: formValues.firstName,
                    from_email: formValues.email,
                    message: formValues.message,
                },
                'jILJIt9q9Y1gnlue9'
            ).then((response) => {
                console.log('Email sent successfully!', response.status, response.text);
                alert(t('contact.messageSuccess'));
                setFormValues({
                    firstName: '',
                    lastName: '',
                    email: '',
                    phone: '',
                    message: ''
                });

            }).catch((err) => {
                console.error('Failed to send email. Error:', err);
                alert(t('contact.messageFail'));
            });
            
            setErrors({});
        }
    };

    const bgColor = isDarkMode ? '#182729' : '#fafafa';
    const textColor = isDarkMode ? '#FAFAFA' : 'black';

    return (
        <section className="h-auto px-8 lg:px-20 xl:px-40 grid place-items-center justify-items-stretch flex-col w-full m-0 mb-16 xl:mt-0 relative">
            <h1 className="text-center mb-16">{t('contact.title')}</h1> {/* Translated Title */}

            <div className="flex flex-col md:flex-row m-0 w-full lg:gap-8 justify-between">
            {/* Left Column - Contact Info */}
            <div
                className="relative w-full md:w-2/5 lg:w-1/2 h-auto px-4 py-2 bg-gray-800 justify-end text-black dark:text-white p-10 flex flex-col bg-cover"
                style={{ backgroundImage: `url('/images/home/host-image.jpg')` }}
            >
                <div className={`absolute inset-0 opacity-50 z-0 ${isDarkMode ? 'bg-dark' : 'bg-white'}`}></div>

                <div className="relative z-10 mb-8">
                <h3
                    className="font-bold mb-3"
                    style={{ color: isDarkMode ? 'white' : 'black' }}
                >
                    {t('contact.addressTitle')}
                </h3>
                <p style={{ color: isDarkMode ? 'white' : 'black' }}>
                    {t('contact.address')}
                </p>
                </div>

                <div className="relative z-10">
                <h3
                    className="font-bold mb-3"
                    style={{ color: isDarkMode ? 'white' : 'black' }}
                >
                    {t('contact.contactTitle')}
                </h3>
                <p style={{ color: isDarkMode ? 'white' : 'black' }}>
                    {t('contact.email')}
                </p>
                </div>
            </div>

            {/* Right Column - Contact Form */}
            <div className="w-full md:w-3/5 md:ml-4 lg:w-1/2 mt-8 md:mt-0 h-9/12 p-0" style={{ backgroundColor: bgColor }}>
                <form onSubmit={handleSubmit}>
                {/* First and Last Name */}
                <div className="flex space-x-4 mb-4">
                    <div className="w-full">
                    <input
                        type="text"
                        name="firstName"
                        placeholder={t('contact.namePlaceholder')}
                        className="w-full outline-blue border-b border-neutral-600 p-3"
                        style={{ backgroundColor: isDarkMode ? '#555' : '#fff', color: textColor }}
                        value={formValues.firstName}
                        onChange={handleChange}
                    />
                    {errors.firstName && (
                        <p className="error" style={{ color: isDarkMode ? 'white' : 'black' }}>
                        {errors.firstName}
                        </p>
                    )}
                    </div>
                </div>

                {/* Email */}
                <div className="mb-4">
                    <input
                    type="text"
                    name="email"
                    placeholder={t('contact.emailPlaceholder')}
                    className="w-full outline-blue border-b border-neutral-600 p-3"
                    style={{ backgroundColor: isDarkMode ? '#555' : '#fff', color: textColor }}
                    value={formValues.email}
                    onChange={handleChange}
                    />
                    {errors.email && (
                    <p className="error" style={{ color: isDarkMode ? 'white' : 'black' }}>
                        {errors.email}
                    </p>
                    )}
                </div>

                {/* Message */}
                <div className="mb-4">
                    <textarea
                    name="message"
                    placeholder={t('contact.messagePlaceholder')} 
                    className="w-full outline-blue border-b border-neutral-600 p-3"
                    style={{ backgroundColor: isDarkMode ? '#555' : '#fff', color: textColor }}
                    value={formValues.message}
                    onChange={handleChange}
                    ></textarea>
                    {errors.message && (
                    <p className="error" style={{ color: isDarkMode ? 'white' : 'black' }}>
                        {errors.message}
                    </p>
                    )}
                </div>

                {/* Submit Button */}
                <div className="mt-6">
                    <button
                    type="submit"
                    className={`w-full py-3 transition duration-300 primary ${isDarkMode && 'dark'}`}
                    >
                    {t('contact.submit')}
                    </button>
                </div>
                </form>
            </div>
            </div>
    </section>

    );
};

export default ContactUs;
